exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container{height:100%\n}\n.app-container .header{height:12.26667vw\n}\n.app-container .app-content{height:100%\n}\n.app-container .app-content.has-header{height:calc(100% - 12.26667vw)\n}\n", ""]);

// exports
